import { Card } from "@/src/components/cards";
import { ExamStep, patientItemStatuses, Sample } from "@/src/data/allTypes";
import { getDayCount, getUserShortName } from "@/src/utils/utils";
import moment from "moment";
import {
  openAnapathStepActionsDialog,
  openAnapathStepStatusDialog,
} from "./anapathStepActions";

export function AnapathStepCard({
  sample,
  step,
  onChange,
}: {
  sample: Sample;
  step: ExamStep;
  onChange: (sample: Sample) => void;
}) {
  return (
    <Card
      key={step.id}
      leading={<div></div>}
      gap="0px"
      title={
        <div className="c1-auto acenter gap10">
          <div>{step.reference?.name}</div>
          <StatusChip
            examStep={step}
            onChange={(step) => {
              onChange(sample);
            }}
          />
        </div>
      }
      onClick={async (e) => {
        e.stopPropagation();
        await openAnapathStepActionsDialog({
          step,
          onChange: async (step) => {
            onChange(sample);
          },
        });
      }}
    >
      {(step?.affectedTo?.length || 0) > 0 && (
        <div>
          <span>Affecté à</span>{" "}
          <strong>
            {step?.affectedTo?.map((user) => getUserShortName(user)).join(", ")}
          </strong>
        </div>
      )}

      <div className="mtop5">
        {step.doneBy && step._modifiedDate && (
          <div>
            <strong className="black">
              Modifié à {getDayCount(step._date, step._modifiedDate)}{" "}
            </strong>
            {moment(step._modifiedDate).format("à HH:mm")}{" "}
            {step.doneBy && (
              <span>
                Par <strong>{getUserShortName(step.doneBy)}</strong>
              </span>
            )}
          </div>
        )}
      </div>

      {step.notes != null && (
        <>
          <div className="mtop5 gray">Notes</div>
          <div className="bold">{step.notes}</div>
        </>
      )}

      {step.conclusion && (
        <>
          <div className="mtop5 gray">Conclusion</div>
          <div className="bold">{step.conclusion}</div>
        </>
      )}
    </Card>
  );
}

function StatusChip({
  examStep,
  onChange,
}: {
  examStep: ExamStep;
  onChange: (step: ExamStep) => void;
}) {
  const statusInfo = patientItemStatuses[examStep.status || "pending"];
  return (
    <div
      className={` br2 p10 center ${statusInfo?.colorName || "gray"}ish`}
      onClick={async (e) => {
        e.stopPropagation();
        await openAnapathStepStatusDialog({
          step: examStep,
          onChange: async (step) => {
            onChange(step);
          },
        });
      }}
    >
      {statusInfo?.name}
    </div>
  );
}
